module.exports = __webpack_public_path__ + "media/images/views/lp/client/risk/risk-ec55e6b9846b339942ec14b570bc542b.jpg";